jQuery(document).on('ready', function() {
   var loadingSpinnerHtml = '<div class="loading-spinner-outer"><div class="loading-spinner"></div></div>';

   var $html = jQuery('html');
   var $document = jQuery(document);

   var lang = $html.attr('lang');
   if (lang == null || lang == undefined || lang == 'null') {
       lang = 'de';
   }
   var baseUrl = window.location.origin + "/" + (lang === "de" ? "" : lang + "/");
   var $productFinderElements = $document.find('.product-finder-element');
   var $searchElements = $document.find('.search-element');

   function addLoadingSpinners($elements) {
       $elements.each(function() {
           $(this).prepend(loadingSpinnerHtml);
       });
   }

   function loadElements(url, $elements) {
       jQuery.get(url, function(data) {
           var initialContent = $(data).html();

           $elements.each(function () {
               var $element = $(this);

               $element.html(initialContent);

               $element.on('change', ':checkbox', function(event) {
                   $element.find('form').trigger('submit');
               });

               submitSearchForm($element);
           });
       });
   }

   function submitSearchForm($element) {
       $element.on('submit', 'form', function(event) {
           event.preventDefault();
           $element.prepend(loadingSpinnerHtml);
           jQuery.get($(this).attr('action'), $(this).serialize(), function(data) {
               $element.find('.results-wrapper').html(
                   $(data).find('.results-wrapper').html()
               );
               $element.find('.loading-spinner-outer').remove();
           });
       });
   }

   if ($productFinderElements.length) {
       var productFinderUrl = baseUrl + "productfinder-ajax";
       addLoadingSpinners($productFinderElements);
       loadElements(productFinderUrl, $productFinderElements);
   }

   if ($searchElements.length) {
       var searchUrl = baseUrl + "search-ajax";
       addLoadingSpinners($searchElements);
       loadElements(searchUrl, $searchElements);
   }
});
